import store from '../../store/store';
import { getClientVersion } from 'owa-config';
import { getUserConfiguration } from 'owa-session-store';

const sessionId = store.sessionId;
const puid = getUserConfiguration().SessionSettings.UserPuid;
const clientVersion = getClientVersion();

export default function getOwsHeaders(correlationId: string) {
    if (correlationId && sessionId && puid && clientVersion) {
        return {
            'x-translator-sid': sessionId,
            'x-translator-cross-sid': sessionId,
            'x-translator-cid': correlationId,
            'x-translator-user-id': puid,
            'x-translator-client-version': clientVersion,
        };
    }
    return undefined;
}
